module.exports = __webpack_public_path__ + "static/img/bg-es.1c09aeff.webp";